import './App.css';
import './styles/main.css'
import './styles/colors.css'
import './styles/fonts.css'
import './styles/pages.css'
import {QueryClientProvider} from "@tanstack/react-query";
import {ColorContextProvider} from "./contexts/ColorContext";
import RoutesConfig from "./routes/routes";
import {UserContextProvider} from "./contexts/UserContext";
import {ClassroomContextProvider} from "./contexts/ClassroomContext";
import 'simplebar-react/dist/simplebar.min.css'
import {MenuContextProvider} from "./contexts/MenuContext";
import {UsersContextProvider} from "./contexts/UsersContext";
import {queryClient} from "./app/queryClient";
import {ToastContextProvider} from "./contexts/ToastContext";
import GradebookTransition from "./components/GradebookTransition";
import { useLocation } from "react-router-dom";
import { isPublicRoute } from "./utils/publicRoutes";

function AppContent() {
    const { pathname } = useLocation();
    const isPublic = isPublicRoute(pathname);

    return (
        <div className="App">
            {!isPublic && <GradebookTransition />}
            <QueryClientProvider client={queryClient}>
                <UserContextProvider>
                    <ClassroomContextProvider>
                        <MenuContextProvider>
                            <UsersContextProvider>
                                <ColorContextProvider>
                                    <ToastContextProvider>
                                        <RoutesConfig/>
                                    </ToastContextProvider>
                                </ColorContextProvider>
                            </UsersContextProvider>
                        </MenuContextProvider>
                    </ClassroomContextProvider>
                </UserContextProvider>
            </QueryClientProvider>
        </div>
    );
}

function App() {
  return <AppContent />;
}

export default App;
